import React from 'react';

import Icon from '../Icon/Icon';

const SupportServiceIcon = (props) => {
    return (
        <Icon width='64' height='64' fill='none' {...props}>
            <ellipse cx='32.0003' cy='19.2497' rx='10.5003' ry='10.4997' fill='#393E44' />
            <path
                d='M11 41.5787C11 37.5468 13.3722 34.0161 17.352 33.3704C20.6504 32.8353 25.4046 32.375 32 32.375C38.5954 32.375 43.3496 32.8353 46.648 33.3704C50.6278 34.0161 53 37.5468 53 41.5787V49.0749C53 51.7111 51.4634 54.0432 48.8846 54.5902C45.6444 55.2776 40.2695 56.0013 32 56.0013C23.7305 56.0013 18.3556 55.2776 15.1154 54.5902C12.5366 54.0432 11 51.7111 11 49.0749V41.5787Z'
                fill='#393E44'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M41.8607 18.5791V20.1573C41.8607 22.6201 39.8641 24.6167 37.4013 24.6167H33.5342V23.6257H37.4013C39.3168 23.6257 40.8697 22.0729 40.8697 20.1573V18.5791H41.8607Z'
                fill='#FFFDFB'
            />
            <rect x='29.9746' y='22.5378' width='4.27146' height='3.16691' rx='1.58346' fill='#FFFDFB' />
            <path
                d='M22.8568 15.3485H20.9638C19.1956 15.3485 17.7622 16.7819 17.7622 18.5501V21.6477C17.7622 23.4159 19.1956 24.8493 20.9638 24.8493H22.0337C22.4883 24.8493 22.8568 24.4807 22.8568 24.0261V15.3485Z'
                fill='#00D1D2'
            />
            <path
                d='M31.7474 7.99999H31.8145C32.2271 7.99998 32.4708 7.99998 32.6824 8.00793C38.2353 8.21677 42.7502 12.4333 43.4231 17.8536C42.8286 17.2983 42.0302 16.9585 41.1524 16.9585H40.7058C39.7259 13.3377 36.4859 10.6527 32.5884 10.5062C32.43 10.5002 32.2367 10.5 31.781 10.5C31.3252 10.5 31.132 10.5002 30.9735 10.5062C27.076 10.6527 23.8361 13.3377 22.8562 16.9585H21.9031C21.2807 16.9585 20.6983 17.1293 20.2001 17.4267C21.051 12.2133 25.4733 8.21125 30.8796 8.00793C31.0911 7.99998 31.3348 7.99998 31.7474 7.99999Z'
                fill='#00D1D2'
            />
            <path
                d='M40.6546 15.3485H42.5476C44.3158 15.3485 45.7492 16.7819 45.7492 18.5501V21.6477C45.7492 23.4159 44.3158 24.8493 42.5476 24.8493H41.4777C41.0231 24.8493 40.6546 24.4807 40.6546 24.0261V15.3485Z'
                fill='#00D1D2'
            />
        </Icon>
    );
};

export default SupportServiceIcon;
